export const matchScore = {
    aria: {
        label: (numberOfStars, maxStars) => `${numberOfStars} out of ${maxStars}`,
    },
};
//# sourceMappingURL=match-score.js.map